import { StoreApi, UseBoundStore, useStore } from "zustand";
import sessionStore from "../store/session-context";

type ExtractState<S> = S extends { getState: () => infer T; } ? T : never;

export const createWithSelectors = (<S extends StoreApi<object>, U>(store: S) => {
	const selectors: any = {};

	for (let key of Object.keys(store.getState())) {
		; const selector = (state: any) => state[key as keyof typeof store];
		const useSelector = () => useStore(store, selector);
		selectors[key] = useSelector;
	}

	const useHook = (selector: (state: ExtractState<S>) => U, equals?: ((a: U, b: U) => boolean) | undefined) =>
		useStore(store, selector, equals);

	useHook.use = selectors;

	return useHook as UseBoundStore<StoreApi<ExtractState<S>>> &
	{
		use: {
			[key in keyof ExtractState<S>]: () => ExtractState<S>[key];
		};
	};
});

const useSessionStore = createWithSelectors(sessionStore);

export default useSessionStore;